import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminApproveLTF.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminApproveLTF' */ './component')],
	render: ([AdminApproveLTF]) => <AdminApproveLTF />,
};

export default routes;
